import React, { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import * as Yup from "yup";
import { Select, Stack } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { BasicForm } from "@components/shared";

const VARIETY_OPTIONS = [
  { value: "1", label: "ClearScreen" },
  { value: "4", label: "Legacy ClearScreen" },
  { value: "2", label: "360" },
  { value: "3", label: "Engagement" },
];

export default function AssessmentInstrumentForm({
  id = null,
  name = "",
  instructionText = "",
  variety = 1,
  allowMultipleTargets = false,
  allowMultipleEvaluators = false,
  onSuccess = () => {},
}) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [selectedVariety, setSelectedVariety] = useState(
    String(variety || 1)
  );
  const isEdit = !!id;

  function onSubmit(formData) {
    setLoading(true);

    if (isEdit) {
      axios
        .put(`/assessment-instruments/${id}/`, {
          name: formData.name,
          instruction_text: formData.instruction_text,
        })
        .then(({ data }) => {
          setLoading(false);
          toast.success(t("updated"));
          onSuccess(data.response[0]);
        })
        .catch((err) => {
          setLoading(false);
          toast.error(err);
        });
      return;
    }

    axios
      .post(`/assessment-instruments/`, {
        name: formData.name,
        instruction_text: formData.instruction_text,
        variety: Number(selectedVariety),
        allow_multiple_targets: !!formData.allow_multiple_targets,
        allow_multiple_evaluators: !!formData.allow_multiple_evaluators,
      })
      .then(({ data }) => {
        setLoading(false);
        toast.success(t("created"));
        onSuccess(data.response[0]);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  const fields = [
    {
      name: "name",
      label: t("name"),
      initialValue: name || "",
      required: true,
      schema: () => Yup.string().required(t("validation:required")),
    },
    {
      name: "instruction_text",
      label: "Instruction text",
      initialValue: instructionText || "",
      textarea: true,
      schema: () => Yup.string(),
    },
  ];

  if (!isEdit) {
    fields.push(
      {
        name: "allow_multiple_targets",
        label: "Allow multiple targets",
        initialValue: !!allowMultipleTargets,
        checkbox: true,
        schema: () => Yup.boolean(),
      },
      {
        name: "allow_multiple_evaluators",
        label: "Allow multiple evaluators",
        initialValue: !!allowMultipleEvaluators,
        checkbox: true,
        schema: () => Yup.boolean(),
      }
    );
  }

  return (
    <Stack gap="sm">
      {!isEdit && (
        <Select
          label={t("variety")}
          data={VARIETY_OPTIONS}
          value={selectedVariety}
          onChange={(value) => setSelectedVariety(value || "1")}
          required
        />
      )}
      <BasicForm
        key={isEdit ? `edit-${id}-${name}` : `create-${selectedVariety}`}
        buttonProps={{ fullWidth: true }}
        loading={loading}
        onSubmit={onSubmit}
        fields={fields}
      />
    </Stack>
  );
}
